import { Link } from 'react-router-dom'

import { useTimerStore } from 'stores'

import {
  Main,
  Heading,
} from 'components'

const About = () => {
  const timers = useTimerStore(state => state.timers)
  
  return (
    <Main center>
      <Heading>About</Heading>

      <p>Era is a simple app that lets you create and view countdown timers with a beautiful interface.</p>
      <p>Created by <a href="https://bengrant.dev" target="_blank" rel="nofollow noreferrer">Ben Grant</a>, Era is designed to solve the ugly, ad-ridden countdown timer market.</p>
      <p>Thank you for using Era. You currently have <strong>{timers.length}</strong> timers.</p>
      <p>If you would like to give feedback or contribute, visit the <a href="https://github.com/GRA0007/era" target="_blank" rel="nofollow noreferrer">GitHub repository</a>.</p>
      <p>View the <Link to="/privacy">privacy policy</Link>.</p>
    </Main>
  )
}

export default About